import { baseApiSlice } from '../../commons/base-api.config';
import {
    API_APPRENTICE_GET_CAMPAIGN_ADS,
    API_CAMPAIGN_ADS_DOWNLOAD_CSV,
    API_CAMPAIGN_ADS__ADD_VERSION,
    API_UPDATE_CAPTIONS,
} from '../../constants/api';
import { HTTP_METHODS } from '../../constants/http';
import {
    IDownloadCloudCampaignCSVRequestPayload,
    IGetCampaignAdsRequestPayload,
    IUpdateCaptionRequestPayload,
} from '../../pages/Apprentice/apprentice.interface';

export const campaignAdsApiSlice = baseApiSlice.injectEndpoints({
    endpoints(builder) {
        return {
            getCampaignAds: builder.query<any, IGetCampaignAdsRequestPayload>({
                query(data) {
                    return {
                        url: API_APPRENTICE_GET_CAMPAIGN_ADS,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                providesTags: ['campaigns'],
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response) => response,
            }),
            addCampaignAdVersion: builder.mutation({
                query: (data) => {
                    return {
                        url: API_CAMPAIGN_ADS__ADD_VERSION,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                transformResponse: (data) => data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            downloadCloudCampaignCSV: builder.mutation<
                any,
                IDownloadCloudCampaignCSVRequestPayload
            >({
                query: (data) => ({
                    url: API_CAMPAIGN_ADS_DOWNLOAD_CSV,
                    method: HTTP_METHODS.POST,
                    body: data,
                    responseHandler: (response) => response.blob(),
                }),
                transformResponse: (response) => response,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
            updateCaption: builder.mutation<string, IUpdateCaptionRequestPayload>({
                query: (data) => {
                    return {
                        url: API_UPDATE_CAPTIONS,
                        method: HTTP_METHODS.POST,
                        body: data,
                    };
                },
                transformResponse: (res: any) => res.data,
                transformErrorResponse: (response: { status: string | number }) => response.status,
            }),
        };
    },
});

export const {
    useLazyGetCampaignAdsQuery,
    useDownloadCloudCampaignCSVMutation,
    useAddCampaignAdVersionMutation,
    useUpdateCaptionMutation,
} = campaignAdsApiSlice;
